import React from 'react';
import './SectionHeader.css';

export interface SectionHeaderProps {
  /** Omit when the page shell (DomainPageShell) already shows this heading. */
  title?: React.ReactNode;
  /** Heading level — use 1 for top-level sidebar panels, 2 for sub-tabs. */
  level?: 1 | 2;
  /** Lede / description rendered below the title. */
  children?: React.ReactNode;
  className?: string;
}

/**
 * Standardised heading + description block used at the top of every
 * inner settings panel, tool tab, or sub-tab content area.
 */
export const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  level = 1,
  children,
  className = '',
}) => {
  const Tag = level === 1 ? 'h1' : 'h2';
  const hasTitle = title != null && title !== '';

  if (!hasTitle && children == null) {
    return null;
  }

  return (
    <header className={`section-header ${className}`.trim()}>
      {hasTitle && <Tag className="section-header__title">{title}</Tag>}
      {children != null && (
        <p className="section-header__lede">{children}</p>
      )}
    </header>
  );
};
